import {ConsumptionPaymentMode, UserTypeEnum} from 'src/enums';

/**
 * The "red name when the user has no Bexio account" warning applies ONLY to:
 *   • drivers and companies without a Bexio account;
 *   • employees who pay for their OWN consumption (EMPLOYEE payment mode) with no Bexio.
 *
 * It must NEVER apply to the business's own staff, nor to employees whose company pays for them
 * (COMPANY payment mode) — those keep the normal (blue) colour.
 *
 * The Bexio flag is a business-side concern (managed by the business owner /
 * managers), so it is also NEVER shown when the logged-in viewer is a company client.
 *
 * `userType` describes the row's user and is data, not authorization, so it stays. The viewer's side
 * is now a boolean the caller derives from their persona rather than a role name passed down here.
 */
export const missingBexioApplies = (params: {
    userType?: UserTypeEnum;
    isCompany?: boolean;
    paymentMode?: ConsumptionPaymentMode;
    viewerIsCompany?: boolean;
}): boolean => {
    const {userType, isCompany, paymentMode, viewerIsCompany} = params;

    // A company (client) user never sees the Bexio warning colouring.
    if (viewerIsCompany) {
        return false;
    }

    if (isCompany || userType === UserTypeEnum.COMPANY) {
        return true;
    }
    if (userType === UserTypeEnum.PRIVATE_DRIVER) {
        return true;
    }
    if (userType === UserTypeEnum.EMPLOYEE) {
        return paymentMode === ConsumptionPaymentMode.EMPLOYEE;
    }
    return false;
};
